import {
  FAQ_CREATE,
  FAQ_ERROR_RESPONSE,
  FAQ_RESPONSE,
  FAQ_REQUEST,
  FAQ_SAVE_REQUEST,
  FAQ_SAVE_RESPONSE,
  FAQ_SAVE_ERROR_RESPONSE,
  FAQ_REMOVE_REQUEST,
  FAQ_REMOVE_RESPONSE,
  FAQ_REMOVE_ERROR_RESPONSE,
  FAQ_ADD_QUESTION,
  FAQ_DELETE_QUESTION,
} from 'constants/action_names';
import * as FaqService from 'services/faq';

export const createFaq = newFaq => ({
  type: FAQ_CREATE,
  newFaq,
});

export const fetchFaqs = faqs => {
  const fetcher = FaqService.list(faqs);

  return dispatch => {
    dispatch({
      type: FAQ_REQUEST,
    });

    return fetcher
      .then(json => {
        dispatch({
          type: FAQ_RESPONSE,
          json,
        });
      })
      .catch(error => {
        dispatch({
          type: FAQ_ERROR_RESPONSE,
          error,
        });
      });
  };
};

export const fetchFaq = faqId => {
  return fetchFaqs(FaqService.get(faqId), faqId);
};

export const saveFaq = faqId => {
  return (dispatch, getState) => {
    const state = getState();
    const faq = {
      ...state.faq.faq.find(e => e.id === faqId),
    };

    dispatch({ type: FAQ_SAVE_REQUEST });

    return FaqService.save(faq)
      .then(() => {
        dispatch({
          type: FAQ_SAVE_RESPONSE,
        });
      })
      .catch(error => {
        console.warn(error);
        dispatch({
          type: FAQ_SAVE_ERROR_RESPONSE,
          error,
        });
      });
  };
};

export const removeFaq = faqId => {
  return (dispatch, getState) => {
    const state = getState();
    const faq = {
      ...state.faq.faq.find(e => e.id === faqId),
    };
    faq.isDeleted = true;

    dispatch({
      type: FAQ_REMOVE_REQUEST,
      faqId,
    });

    return FaqService.save(faq)
      .then(() => {
        dispatch({
          type: FAQ_REMOVE_RESPONSE,
          faqId,
        });
      })
      .catch(error => {
        console.warn(error);
        dispatch({
          type: FAQ_REMOVE_ERROR_RESPONSE,
          error,
        });
      });
  };
};

export const addQuestion = (faqId, question = null) => ({
  type: FAQ_ADD_QUESTION,
  faqId,
  question,
});

export const deleteQuestion = (faqId, questionId) => ({
  type: FAQ_DELETE_QUESTION,
  faqId: faqId,
  questionId,
});
